import { Button as AntdButton, ButtonProps } from 'antd';
import cx from 'classnames';
import { useTheme } from '@ui/hooks';
import { AntdConfigProvider } from '..';
import './styles.css';

export const Button = (props: ButtonProps) => {
  const { className, ...rest } = props;
  const { baseButton } = useTheme();
  return (
    <AntdConfigProvider
      theme={{
        components: { Button: { ...baseButton, paddingBlock: '0.25rem', contentLineHeight: 1.5 } },
      }}
    >
      <AntdButton
        className={cx('styled-button leading-normal py-1', className)}
        shape="round"
        {...rest}
      />
    </AntdConfigProvider>
  );
};
